import { render } from "./Activation3.vue?vue&type=template&id=20c83420"
import script from "./Activation3.vue?vue&type=script&lang=js"
export * from "./Activation3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__